const STORAGE_KEY = "wembii.instagramReelHighQuality";

export type InstagramVideoQuality = "standard" | "high";

export function getInstagramHighQualityPreference(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function setInstagramHighQualityPreference(enabled: boolean): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, enabled ? "1" : "0");
  } catch {
    /* ignore quota / private mode */
  }
}

export function resolveInstagramVideoQuality(
  highQualityEnabled: boolean
): InstagramVideoQuality {
  return highQualityEnabled ? "high" : "standard";
}
